"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallToActionSchema = void 0;
exports.CallToActionSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "CallToAction",
    "description": "A call for a given action, e.g. to watch a video, follow a Facebook user or to buy a ticket (through an web-link)",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:call-to-action"
            ]
        },
        "actionEndDateTime": {
            "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
            "description": "When should the call-to-action be no longer available. E.g. for time-bound ticket-sale links."
        },
        "actionMotivationDescription": {
            "type": "string",
            "description": "An additional text describing why an action should be taken.",
            "deprecated": true,
            "deprecationReason": "This property will be removed in one of the upcoming releases"
        },
        "actionStartDateTime": {
            "$ref": "https://www.redbull.com/schemas/attributes/date-time.schema.json",
            "description": "Time from when the call to action is available, e.g. for buy-ticket links where sale starts at a specific point in time"
        },
        "actionTargets": {
            "type": "array",
            "items": {
                "oneOf": [
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/reference-link.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/web-link.schema.json"
                    },
                    {
                        "type": "object",
                        "$ref": "https://www.redbull.com/schemas/attributes/anchor.schema.json"
                    }
                ]
            },
            "minItems": 1
        },
        "actionType": {
            "type": "string",
            "description": "The action type allows consumers to distinguish and/or cluster certain actions based on their intent.",
            "enum": [
                "buyGear",
                "buyTicket",
                "listen",
                "read",
                "register",
                "watch",
                "anchor",
                "ecommerce",
                "theRedBulletinMore",
                "theRedBulletinRead",
                "theRedBulletinSubscribe"
            ]
        },
        "labelLong": {
            "type": "string",
            "maxLength": 200,
            "deprecated": true,
            "deprecationReason": "This property will be removed in one of the upcoming releases"
        },
        "labelShort": {
            "type": "string",
            "description": "The short label may be used on action buttons, etc.",
            "maxLength": 50
        }
    },
    "required": [
        "labelShort",
        "type",
        "actionTargets"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FsbC10by1hY3Rpb24uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9jYWxsLXRvLWFjdGlvbi5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxrQkFBa0IsR0FBRztJQUNoQyxLQUFLLEVBQUUsdUVBQXVFO0lBQzlFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLGNBQWM7SUFDdkIsYUFBYSxFQUFFLG1IQUFtSDtJQUNsSSxNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTiwyQkFBMkI7YUFDNUI7U0FDRjtRQUNELG1CQUFtQixFQUFFO1lBQ25CLE1BQU0sRUFBRSxrRUFBa0U7WUFDMUUsYUFBYSxFQUFFLCtGQUErRjtTQUMvRztRQUNELDZCQUE2QixFQUFFO1lBQzdCLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLGFBQWEsRUFBRSw4REFBOEQ7WUFDN0UsWUFBWSxFQUFFLElBQUk7WUFDbEIsbUJBQW1CLEVBQUUsK0RBQStEO1NBQ3JGO1FBQ0QscUJBQXFCLEVBQUU7WUFDckIsTUFBTSxFQUFFLGtFQUFrRTtZQUMxRSxhQUFhLEVBQUUseUhBQXlIO1NBQ3pJO1FBQ0QsZUFBZSxFQUFFO1lBQ2YsTUFBTSxFQUFFLE9BQU87WUFDZixPQUFPLEVBQUU7Z0JBQ1AsT0FBTyxFQUFFO29CQUNQO3dCQUNFLE1BQU0sRUFBRSxRQUFRO3dCQUNoQixNQUFNLEVBQUUsdUVBQXVFO3FCQUNoRjtvQkFDRDt3QkFDRSxNQUFNLEVBQUUsUUFBUTt3QkFDaEIsTUFBTSxFQUFFLGlFQUFpRTtxQkFDMUU7b0JBQ0Q7d0JBQ0UsTUFBTSxFQUFFLFFBQVE7d0JBQ2hCLE1BQU0sRUFBRSwrREFBK0Q7cUJBQ3hFO2lCQUNGO2FBQ0Y7WUFDRCxVQUFVLEVBQUUsQ0FBQztTQUNkO1FBQ0QsWUFBWSxFQUFFO1lBQ1osTUFBTSxFQUFFLFFBQVE7WUFDaEIsYUFBYSxFQUFFLHVHQUF1RztZQUN0SCxNQUFNLEVBQUU7Z0JBQ04sU0FBUztnQkFDVCxXQUFXO2dCQUNYLFFBQVE7Z0JBQ1IsTUFBTTtnQkFDTixVQUFVO2dCQUNWLE9BQU87Z0JBQ1AsUUFBUTtnQkFDUixXQUFXO2dCQUNYLG9CQUFvQjtnQkFDcEIsb0JBQW9CO2dCQUNwQix5QkFBeUI7YUFDMUI7U0FDRjtRQUNELFdBQVcsRUFBRTtZQUNYLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFdBQVcsRUFBRSxHQUFHO1lBQ2hCLFlBQVksRUFBRSxJQUFJO1lBQ2xCLG1CQUFtQixFQUFFLCtEQUErRDtTQUNyRjtRQUNELFlBQVksRUFBRTtZQUNaLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLGFBQWEsRUFBRSxxREFBcUQ7WUFDcEUsV0FBVyxFQUFFLEVBQUU7U0FDaEI7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLFlBQVk7UUFDWixNQUFNO1FBQ04sZUFBZTtLQUNoQjtDQUNGLENBQUEifQ==